import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { transform } from 'ol/proj';

export type GoogleLocationType = 'ROOFTOP' | 'RANGE_INTERPOLATED' | 'GEOMETRIC_CENTER' | 'APPROXIMATE';
export interface GoogleGeocodeResult {
	status: 'OK'; // other types are not handled
	results: {
		address_components;
		formatted_address;
		geometry: {
			location_type: GoogleLocationType;
			location;
			bounds;
		};
		place_id;
		types;
	}[];
}
export interface AddressResult {
	addr: string;
	coord?: number[];
	boundsExtent?: [number, number, number, number];
	locationType?: GoogleLocationType;
}

@Injectable({
  providedIn: 'root'
})
export class AddressService {

	constructor(
		private http: HttpClient
	) { }

	// Check if address string is latlong decimal format
	isLatLongDecimal(addressString) {
		const separators = [' ', ','];
		for (let i = 0; i < separators.length; i++) {
			const parts = addressString.split(separators[i]);
			if (parts.length === 2) {
				parts[0] = parts[0].replace(/^[,\s]+|[,\s]+$/g, '');
				parts[1] = parts[1].replace(/^[,\s]+|[,\s]+$/g, '');
				//if the two numbers are between normal range of lat and long
				if ((Number(parts[0]) >= -90 && Number(parts[0]) <= 90 ) &&
					(Number(parts[1]) >= -180 && Number(parts[1]) <= 180) ) {
					return [Number(parts[1]), Number(parts[0])];
				}
			}						
		}
	};

	// !!!!!!!!!!! TODO: THIS FUNCTION NEED TO BE REWRITTEN !!!!!!
	// Check if address string is latlong degree by checking degree(°) symbol ??
	// Convert it to decimal format
	isLatLongDMS(addrStr) {
		// https://stackoverflow.com/questions/1140189/converting-latitude-and-longitude-to-decimal-values
		const convertDMSToDD = (str, direction) => {
			if (!str) {
				return;
			}
			let degrees = 0;
			let minutes = 0;
			let seconds: any = 0;
			let msPart;
			// Separate degree
			degrees = str.split('\xB0')[0];
			msPart = str.split('\xB0')[1];
			const secSeparators = ['\'\'', '\"'];
			let hasSecSeparator = false;
			for (let i = 0; i <= secSeparators.length; i++) {
				if (msPart.indexOf(secSeparators[i]) !== -1) {
					msPart = msPart.split(secSeparators[i])[0];
					if (msPart.indexOf('\'') !== -1) {
						minutes = msPart.split('\'')[0];
						seconds = msPart.split('\'')[1];
					} else {
						seconds = msPart;
					}
					// Remove secondSeparator from seconds
					seconds = seconds.split(secSeparators[i])[0];
					hasSecSeparator = true;
					break;
				}
			}
			if (!hasSecSeparator) {
				if (msPart.indexOf('\'') !== -1) {
					minutes = msPart.split('\'')[0];
				}
			}
			// if (msPart.indexOf('\'\'') !== -1) {
			// 	msPart = msPart.split('\'\'')[0];
			// 	if (msPart.indexOf('\'') !== -1) {
			// 		minutes = msPart.split('\'')[0];
			// 		seconds = msPart.split('\'')[1];
			// 	} else {
			// 		seconds = msPart;
			// 	}
			// } else {
			// 	if (msPart.indexOf('\'') !== -1) {
			// 		minutes = msPart.split('\'')[0];
			// 	}
			// }
			let dd = Number(degrees) + Number(minutes)/60 + Number(seconds)/(60*60);
			if (direction && (direction.toUpperCase() == 'S' || direction.toUpperCase() == 'W')) {
				dd = dd * -1;
			} // Don't do anything for N or E
			return dd;
		}
		// Has degree symbol (°) or not
		if (addrStr.indexOf('\xB0') === -1) {
			return;
		}
		// Remove all the white space / comma at beginning and end
		addrStr = addrStr.replace(/^[,\s]+|[,\s]+$/g, '').replace(/,/g, '');
		// Split by letters (should be 'N' / 'S' / 'E' / 'W')
			// addrStr = addrStr.replace(/([A-Za-z])/g, function(x){return x + ','});
			// const latParts = addrStr.split(',')[0];
			// const longParts = addrStr.split(',')[1];
		const parts = addrStr.split(/([A-Za-z])/g); // eg. ["33° 15' ", "N", " 114° 0' 36'' ", "W", ""]
		let lat, lng;
		if (parts.length <= 2) {
			// lat = convertDMSToDD(parts[0]);
			// lng = convertDMSToDD(parts[1]);
		} else {
			lat = convertDMSToDD(parts[0], parts[1]);
			lng = convertDMSToDD(parts[2], parts[3]);
		}
		return [lng, lat];
			// const latParts = latRaw.split(/[^\d\w]+/);
			// const longParts = longRaw.split(/[^\d\w]+/);
	}

	// Convert latlong from number to degree format, ie. aa.bbbb -> xx°yy'zz" E
	latlongDecimalToDMS(longNum, latNum) {
		const toDMS = (n) => {
			const absolute = Math.abs(n);
			const degrees = Math.floor(absolute);
			const minutes = Math.floor((absolute - degrees) * 60);
			const seconds = Math.floor(((absolute - degrees) * 60 - minutes) * 60);
			return degrees + '°' + minutes + '\'' + seconds + '\"'; 
		};
		let longDMS, latDMS;
		let longDirection = 'E';
		let latDirection = 'N';
		if (longNum < 0) {
			longDirection = 'W';
		}
		if (latNum < 0) {
			latDirection = 'S';
		}
		longDMS = toDMS(longNum) + longDirection;
		latDMS = toDMS(latNum) + latDirection;
		return [longDMS, latDMS];
	}

	searchAddressByGoogle(addressStr: string) {
		return new Promise<AddressResult[]>((resolve, reject) => {
			const url = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + addressStr + '&key=AIzaSyDb8xKLVxkLQV64Zqu3SFBF_6g9cZAp-0M';			
			this.http.get(url)
			.subscribe((rsp: GoogleGeocodeResult) => {
				if (rsp.status === 'OK') {
					const addresses: AddressResult[] = [];
					rsp.results.forEach(r => {
						const address: AddressResult = {
							addr: r.formatted_address,
							locationType: r.geometry.location_type
						};
						const location = r.geometry.location;
						const srcProject = 'EPSG:4326';
						const targetProject = 'EPSG:3857';
						const coord = transform([location.lng,location.lat], srcProject, targetProject);
						address.coord = coord;
						const bounds = r.geometry.bounds;
						if (r.geometry.location_type!=='ROOFTOP' && bounds) {
							const min = transform([bounds.southwest.lng, bounds.southwest.lat], srcProject, targetProject);
							const max = transform([bounds.northeast.lng,bounds.northeast.lat], srcProject, targetProject);
							const boundsExtent: [number, number, number, number] = [min[0], min[1], max[0], max[1]];
							address.boundsExtent = boundsExtent;		
						}
						addresses.push(address);
					});
					resolve(addresses);
				}
				resolve([]);
				// $('.matchloc-popup').css('display','block');
				// $scope.matchLocation = results[0];
				// if (results.length<6) {
				// 	$scope.matchLocsListSize = results.length +1;
				// } else {
				// 	$scope.matchLocsListSize = 7;
				// };
			}, err => {
				resolve([]);
				console.log(err);
			});
		});
	}
}
